export const expirationTime = () => {
  const expirationTime = new Date();
  expirationTime.setDate(expirationTime.getDate() + 30); // Add 30 days
  return expirationTime;
};

// export const expirationTime = (): Date => {
//     const expirationTime = new Date();
//     expirationTime.setMinutes(expirationTime.getMinutes() + 1); // Add 1 minute
//     console.log('time', expirationTime);
//     return expirationTime;
// }
